import { call, delay, put, select, take } from 'redux-saga/effects';
import {
  selectors as loginSelectors,
  actionTypes as loginActionTypes,
} from '../reducers/Login';
import offlineActions, {
  actionTypes as offlineActionTypes,
  selectors as offlineSelectors,
} from '../reducers/Offline';
import { fulfilled, rejected } from '../factories/ApiCall';

import _ from 'lodash';
import { MAX_REQUEST_TRIALS, offline_mode } from '../../Constants';
import { refreshToken } from './Login';

export default function* webRequest(apifunc) {
  let trial_count = 0;

  while (true) {
    const logged_in = yield select(loginSelectors.logged_in);
    if (!logged_in) {
      yield take(loginActionTypes.LOGIN_SITE_FULFILLED);
    }
    try {
      trial_count += 1;
      const response = yield call(apifunc);
      return response;
    } catch (error) {
      const status = error.response?.status;

      if (status === 409) {
        throw error;
      }

      // If more than MAX_REQUEST_TRIALS then throw error
      if (trial_count > MAX_REQUEST_TRIALS) {
        throw error;
      }

      // ######################################################
      // Offline mode handling
      // ######################################################

      if (offline_mode) {
        // Re try after 1 sec
        if (status === 404) {
          throw error;
        }

        yield delay(1000);
        continue;
      }

      const offline_mode_available = yield select(
        offlineSelectors.is_offline_mode_available
      );
      if (
        offline_mode_available &&
        !_.includes([401, 400, 403, 404, 409, 422, 500, 503], status)
      ) {
        yield put(offlineActions.setOnlineAvailable(false));
        // wait for user to make decision what to do and then retry the call
        yield take(offlineActionTypes.RE_TRY_REQUEST);
        // restart the action
        continue;
      }

      // ######################################################
      // Refresh  handling
      // ######################################################
      if (
        status === 401 || // expired token
        status === 422 // unprocessable entity
      ) {
        // invalid token
        // Try to refresh token, and retry the request
        yield call(refreshToken);
        continue;
      }

      // Retry after 1 s.
      yield delay(1000);
    }
  }
}

export function* fetchAndPut(apifunc, action) {
  try {
    const { data } = yield call(webRequest, apifunc(action.payload));
    yield put({ type: fulfilled(action.type), payload: data });
  } catch (e) {
    yield put({ type: rejected(action.type), payload: e });
  }
}
